import React, { useState } from 'react';
import SettingsCard from '../../../../../shared/components/structure/SettingsCard';
import ManageSparkLocationsForm from './ManageSparkLocationsForm';
import OrganizationContainer from '../../../../../shared/state/containers/OrganizationContainer';
import ApplicationModel from '../../../../../shared/models/applications/api/ApplicationModel';
import TemplateFormSectionModel from '../../../../../shared/models/templating/api/TemplateFormSectionModel';
import TemplateFormFieldModel from '../../../../../shared/models/templating/api/TemplateFormFieldModel';
import ApplicationContainer from '../../../../../shared/state/containers/ApplicationContainer';
import { css } from '@emotion/css';
import { AutofillFieldState, LocationSubStep } from './SparkLocationsForm';

interface OrganizationApplicationsProps {
    appContainer: ApplicationContainer
    orgContainer: OrganizationContainer
    commonApp: ApplicationModel
    locationApps?: ApplicationModel[]
    manageMenuApps?: ApplicationModel[]
    locationAppNames: string[]
    commonAppSections: TemplateFormSectionModel[]
    locationAppFormFields: TemplateFormFieldModel[];
    isLoadingTemplates: boolean
    history: any
    padding?: string
}

const OrganizationApplications: React.FC<OrganizationApplicationsProps> = (props) => {
    const [isSubmittingForm, setIsSubmittingForm] = useState<boolean>(false);
    const [progressStep, setProgressStep] = useState<string>('');
    const [progressLocationName, setProgressLocationName] = useState<string>('');
    const [progressMode, setProgressMode] = useState<'creating' | 'updating'>('creating');
    const [locationProgress, setLocationProgress] = useState<Record<string, LocationSubStep>>({});
    const [autofillProgress, setAutofillProgress] = useState<Record<string, AutofillFieldState>>({});

    return (
        <SettingsCard
            title="Assistant Configuration"
            bodyStyle={bodyStyle}
            isLoading={props.isLoadingTemplates}
        >
            <ManageSparkLocationsForm
                appContainer={props.appContainer}
                orgContainer={props.orgContainer}
                commonApp={props.commonApp}
                locationApps={props.locationApps}
                manageMenuApps={props.manageMenuApps}
                locationAppNames={props.locationAppNames}
                commonAppSections={props.commonAppSections}
                locationAppFormFields={props.locationAppFormFields}
                isLoadingTemplates={props.isLoadingTemplates}
                history={props.history}
                isSubmittingForm={isSubmittingForm}
                setIsSubmittingForm={setIsSubmittingForm}
                progressStep={progressStep}
                setProgressStep={setProgressStep}
                progressLocationName={progressLocationName}
                setProgressLocationName={setProgressLocationName}
                progressMode={progressMode}
                setProgressMode={setProgressMode}
                locationProgress={locationProgress}
                setLocationProgress={setLocationProgress}
                autofillProgress={autofillProgress}
                setAutofillProgress={setAutofillProgress}
                padding={props.padding}
            />
        </SettingsCard>
    );
}

const bodyStyle = css`
    padding: 0px;
`;

export default OrganizationApplications;
